import { invoiceSpecificationRead } from "@/schemas/invoiceSpecification";
import { ReadInvoiceSpecification } from "@/types/invoiceSpecification";
import { invoiceSpecificationsService } from "@/services/invoiceSpecifications";
import StandardQueryTable from "@/components/StandardQueryTable";
import { generatePath } from "react-router-dom";
import { PATH_INVOICE_SPECIFICATIONS_DETAILS } from "@/constants";
import { useInvoiceSpecificationList } from "../hooks/useInvoiceSpecificationList";

export const InvoiceSpecificationsList = () => {
  const { columnOverrides, tableFeatures } = useInvoiceSpecificationList();

  return (
    <StandardQueryTable<ReadInvoiceSpecification>
      schema={invoiceSpecificationRead}
      name="projectInvoiceSpecifications"
      fetchList={invoiceSpecificationsService.getList}
      pathBuilder={(row) =>
        generatePath(PATH_INVOICE_SPECIFICATIONS_DETAILS, {
          invoiceSpecificationId: row.id,
        })
      }
      translationKey="projectInvoiceSpecifications"
      columnOverrides={columnOverrides}
      tableFeatures={tableFeatures}
      actions={[]}
    />
  );
};
